<div class="report-notification">
  <div class="report-notification__spinner">
    @if (!isComplete && !hasError) {
      <mat-spinner color="primary" diameter="30"></mat-spinner>
    }
    @if (isComplete && !hasError) {
      <mat-icon
        class="report-notification__icon report-notification__icon--success"
        >check_circle</mat-icon
      >
    }
    @if (hasError) {
      <mat-icon
        class="report-notification__icon report-notification__icon--error"
        >error</mat-icon
      >
    }
  </div>

  <div class="report-notification__content">
    @if (!isComplete && !hasError) {
      <div class="report-notification__title">
        {{ 'reports.notifications.downloadInProgress' | translate }}
      </div>
      <div class="report-notification__subtitle">
        {{ 'reports.notifications.downloadingOperationReport' | translate }}
      </div>
    }
    @if (isComplete && !hasError) {
      <div class="report-notification__title">
        {{ 'reports.notifications.downloadComplete' | translate }}
      </div>
      <div class="report-notification__subtitle">
        {{ 'reports.notifications.fileDownloadedSuccessfully' | translate }}
      </div>
    }
    @if (hasError) {
      <div class="report-notification__title">
        {{ 'reports.notifications.downloadError' | translate }}
      </div>
      <div class="report-notification__subtitle">
        {{ errorMessage | translate }}
      </div>
    }
  </div>

  <div class="report-notification__close">
    <a
      (click)="closeDialog()"
      (keyup.enter)="closeDialog()"
      (keyup.space)="closeDialog()"
      class="report-notification__close-button"
      tabindex="0"
      role="button"
      aria-label="Close notification"
    >
      <mat-icon class="report-notification__close-icon">close</mat-icon>
    </a>
  </div>
</div>
